import React from 'react';
import { ReferenceInput } from 'react-admin';

const FormReferenceInput = (props) => {
    return <ReferenceInput {...props} variant="outlined" margin="none" />;
};

export default FormReferenceInput;
